import { UpperCasePipe } from "@angular/common";
import { ChangeDetectionStrategy, Component, input, Input } from "@angular/core";
import { FormGroup, FormsModule, ReactiveFormsModule } from "@angular/forms";
import { MatOption } from "@angular/material/core";
import { MatFormField, MatLabel } from "@angular/material/form-field";
import { MatInput } from "@angular/material/input";
import { MatSelect } from "@angular/material/select";
import { TranslatePipe } from "@ngx-translate/core";
import { Entity } from "../../classes/flow/base/Entity";
import { QuestionnaireType } from "../../classes/flow/Questionnaire/QuestionnaireType";
import { Specialty } from "../../classes/flow/Questionnaire/Specialty";
import { compareEntities } from "../../helpers/compareObjects";
import { InputErrorComponent } from "../error/error.component";

@Component({
  selector: "app-questionnaire-form[formGroup]",
  templateUrl: "./questionnaire-form.component.html",
  styleUrls: ["./questionnaire-form.component.less"],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    FormsModule,
    ReactiveFormsModule,
    MatFormField,
    MatLabel,
    MatInput,
    InputErrorComponent,
    MatSelect,
    MatOption,
    UpperCasePipe,
    TranslatePipe,
  ],
})
/**
 * A component for basic details of a questionnaire.
 * The specified formGroup should contain a:
 * - title
 * - description
 * - specialties collection
 */
export class QuestionnaireFormComponent {
  @Input("formGroup")
  public formGroup!: FormGroup;

  public allSpecialties = input.required<Specialty[]>();
  public allQuestionnaireTypes = input.required<QuestionnaireType[]>();

  /**
   * Compares two entities
   * @param firstEntity The first entity
   * @param secondEntity The second entity
   * @returns True if the entities are equal, false otherwise
   */
  public compareEntities(firstEntity: Entity, secondEntity: Entity) {
    return compareEntities(firstEntity, secondEntity);
  }
}
